import api from './api';
import localforage from "localforage";

export const fetchInstructions = () => async dispatch => {
  if (window.navigator.onLine) {
      return window.axios.get(api.instructions.index)
          .then(async (response) => {
              await localforage.setDriver(localforage.INDEXEDDB);
              await localforage.setItem('bs_instructions', response.data);

              return Promise.resolve({ ...response.data });
          })
          .catch(error => {
              return Promise.reject(error)
          });
  } else {
      try {
          await localforage.setDriver(localforage.INDEXEDDB);
          const instructions = await localforage.getItem('bs_instructions');

          return Promise.resolve(instructions)
      } catch (e) {
          return Promise.reject(e);
      }
  }
};
